// extracted by mini-css-extract-plugin
module.exports = {"details":"CardDeal_details__kw2bC"};